// extracted by mini-css-extract-plugin
export default {"loader":"loading__loader__pUYJC","spin":"loading__spin___BMim","bdrad":"loading__bdrad__BU2jK"};